import React from "react";
import { Download, Smartphone, Apple } from "lucide-react";
import Orb from "../IntroPage/Orb";
import BlurText from "@/router/ui/BlurText";
import AuraNexusLogo from "@/assets/AuraNexus_logo.png";
import PoliceLogo from "@/assets/police_logo.png";
import "./DownloadPage.css";
import "../IntroPage/Orb.css";

const DownloadPage: React.FC = () => {
  const handleAndroidDownload = () => {
    // 创建一个隐藏的下载链接
    const link = document.createElement("a");
    link.href = "https://aura-nexus.com/downloads/apk/";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleIOSDownload = () => {
    window.open("https://testflight.apple.com/join/H1MSZjvz", "_blank");
  };

  return (
    <div className="download-page-container">
      {/* Orb Background */}
      <div className="orb-background">
        <Orb
          hoverIntensity={0.4}
          rotateOnHover={true}
          forceHoverState={false}
        />
      </div>

      {/* Content Container */}
      <div className="content-container">
        <div className="download-screen">
          <div className="logo-container">
            <img src={AuraNexusLogo} alt="AuraNexus Logo" className="logo" />
          </div>

          <BlurText
            text="欢迎体验 MediSimAI"
            delay={50}
            animateBy="words"
            direction="top"
            className="download-title"
            stepDuration={0.2}
          />

          <div className="download-description">
            <BlurText
              text="你好！很高兴邀请你成为我们的首席体验官"
              delay={80}
              animateBy="words"
              direction="top"
              className="download-subtitle"
              stepDuration={0.3}
            />
            <br />
            <BlurText
              text="MediSimAI 是一个专为医学生和医疗从业者设计的AI问诊练习平台。无论你是在宿舍、图书馆还是通勤路上，都可以随时随地与虚拟患者进行问诊对话，提升你的临床思维和沟通技巧。"
              delay={100}
              animateBy="words"
              direction="top"
              className="download-intro"
              stepDuration={0.3}
            />
            <br />
            <BlurText
              text="我们诚挚邀请你下载体验，并期待你的宝贵反馈！"
              delay={120}
              animateBy="words"
              direction="top"
              className="download-invitation"
              stepDuration={0.3}
            />
          </div>

          {/* Download Buttons */}
          <div className="download-buttons">
            <button
              onClick={handleAndroidDownload}
              className="download-btn android-btn"
            >
              <Smartphone size={24} />
              <div className="btn-content">
                <span className="btn-title">Android 用户</span>
                <span className="btn-subtitle">
                  点击下载 APK 成为首席体验官
                </span>
              </div>
              <Download size={20} className="download-icon" />
            </button>

            <button
              onClick={handleIOSDownload}
              className="download-btn ios-btn"
            >
              <Apple size={24} />
              <div className="btn-content">
                <span className="btn-title">iOS 用户</span>
                <span className="btn-subtitle">
                  加入 TestFlight 成为首席体验官
                </span>
              </div>
              <Download size={20} className="download-icon" />
            </button>
          </div>

          {/* Version Info */}
          <div className="version-info">
            <BlurText
              text="当前版本：v1.1.0 Beta"
              delay={120}
              animateBy="words"
              direction="top"
              className="version-text"
              stepDuration={0.3}
            />
          </div>
        </div>
      </div>

      {/* 备案信息 */}
      <div className="filing-info">
        <div className="filing-links">
          <a
            href="https://beian.miit.gov.cn/"
            target="_blank"
            rel="noopener noreferrer"
            className="filing-link"
          >
            陕ICP备2025076219号-1
          </a>
          <span className="filing-separator">|</span>
          <a
            href="https://beian.mps.gov.cn/#/query/webSearch?code=61011302002156"
            target="_blank"
            rel="noopener noreferrer"
            className="filing-link police-filing"
          >
            <img
              src={PoliceLogo}
              width="16"
              height="16"
              alt="公安备案"
              className="police-logo"
            />
            陕公网安备61011302002156号
          </a>
        </div>
      </div>
    </div>
  );
};

export default DownloadPage;
